import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "phone-model",
  "use": "phone-model-usage",
  "viewBox": "0 0 323 616",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 323 616\" id=\"phone-model\">\n  <defs>\n    <style>\n      #phone-model .cls-1 {\n        fill: rgba(0,0,0,0.05);\n      }\n\n      #phone-model .cls-2 {\n        fill: #fff;\n      }\n    </style>\n  </defs>\n  <g id=\"phone-model_white\" transform=\"translate(1139 -662)\">\n    <rect id=\"phone-model_base\" class=\"cls-1\" width=\"323\" height=\"616\" rx=\"20\" transform=\"translate(-1139 662)\" />\n    <rect id=\"phone-model_mask\" class=\"cls-2\" width=\"293\" height=\"590\" rx=\"20\" transform=\"translate(-1125 675)\" />\n    <path id=\"phone-model_bar\" class=\"cls-1\" d=\"M0,0H147a0,0,0,0,1,0,0V0a21,21,0,0,1-21,21H21A21,21,0,0,1,0,0V0A0,0,0,0,1,0,0Z\" transform=\"translate(-1052 675)\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/phone-model.svg
// module id = UGdP
// module chunks = 6